import { setupI18n } from '@lingui/core';
import { messages as deMessages } from '../locales/de/messages';
import { messages as enMessages } from '../locales/en/messages';
import type { DocumentType as BookitupDocumentType, Language } from './DocumentT';

type DocumentLocale = 'de' | 'en';

const getLocale = (language?: Language | null): DocumentLocale => (language === 'english' ? 'en' : 'de');

const documentI18n = {
  de: setupI18n({ locale: 'de', messages: { de: deMessages } }),
  en: setupI18n({ locale: 'en', messages: { en: enMessages } }),
};

const translate = (language: Language | null | undefined, id: string, values?: Record<string, string | number>) =>
  documentI18n[getLocale(language)]._(id, values);

const documentType = (language: Language | null | undefined, type: BookitupDocumentType, finalInvoice?: boolean) =>
  translate(language, finalInvoice ? 'document.final_invoice' : `document.${type.toLowerCase()}`);

const DocumentLanguageS = {
  documentType,
  translate,
};

export default DocumentLanguageS;
